import { render, staticRenderFns } from "./orgUserDefinedDialog.vue?vue&type=template&id=05b49558&scoped=true&"
import script from "./orgUserDefinedDialog.vue?vue&type=script&lang=js&"
export * from "./orgUserDefinedDialog.vue?vue&type=script&lang=js&"
import style0 from "./orgUserDefinedDialog.vue?vue&type=style&index=0&id=05b49558&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b49558",
  null
  
)

export default component.exports